import React from 'react';
import MaterialDialogContent from '@mui/material/DialogContent';
import type {DialogContentProps as MaterialDialogContentProps} from '@mui/material/DialogContent';

export type ModalContentProps = MaterialDialogContentProps;

export const ModalContent = React.forwardRef<any, ModalContentProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <MaterialDialogContent
                ref={ref}
                {...props}
            >
                {children}
            </MaterialDialogContent>
        );
    });

ModalContent.displayName = 'ModalContent';
